import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col, Button,
} from "reactstrap";

import {getStats} from "../../components/helpers/StatsHelpers";
import {RiBookMarkedFill} from "react-icons/ri";
import {SeoHelper} from "../../components/helpers/SeoHelper";
import InstructionsWizard from "./InstructionsWizard";

class CreateACuratedSongFlowFromScriptureHelp extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);

    // sessionStorage.removeItem("customer");
  }

  chooseSongBook= sessionStorage.getItem("customer") ?     {
    title: "Choosing a song book",
    description: "<img src=\"/help-images/create-a-curated-song-flow-from-scripture/choose-song-book-not-logged-in.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
        "<br/><br/>"
  }: {
    title: "Choosing a song book",
    description: "<img src=\"/help-images/create-a-curated-song-flow-from-scripture/choose-song-book-not-logged-in.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
        "<br/><br/>From the list highlight the song book you wish to use:" +
        "<img src=\"/help-images/create-a-curated-song-flow-from-scripture/choose-song-book-not-logged-in-dropdown.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
        "<br/><br/>Click on the song book to select it:" +
        "<img src=\"/help-images/create-a-curated-song-flow-from-scripture/choose-song-book-not-logged-in-dropdown-selected.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
        "<br/><br/>Now press the <img src=\"/help-images/create-a-curated-song-flow-from-scripture/choose-song-book-not-logged-in-add-button.png\" style=\"width: 150px; height: auto;\"> button and " +
        "the song book will be listed below." +
        "<img src=\"/help-images/create-a-curated-song-flow-from-scripture/choose-song-book-not-logged-in-added.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
        "<br/><br/>Press the Continue button at the bottom of the page."
  }


  stepsData = [
    {
      title: "Create a curated song-flow from Scripture",
      description: "At the end of this guide you will have:<br/><br/> " +
          "<img src=\"/help-images/blue-arrow.png\" style=\"width: 40px; height: auto;\">&nbsp;" +
          "created your first song-flow using Scripture as the starting point"
    },
    {
      title: "From the home page",
      description: "The <a href='/scripture/choose-song-book'>Build from Scripture</a> feature is placed at various points on <a href='/'>The Worship Bible</a> website. " +
          "However, the easiest place to locate it at first is on the <a href='/'>Home</a> page" +
          "<img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-home-page.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
          "<br/><br/>Click on the <a href='/scripture/choose-song-book'>Build from Scripture</a> button to start"
    },
    this.chooseSongBook,
    {
      title: "Choosing a passage",
      description: "You can now select one or more Scripture passages that will used to find related songs within the selected song book(s) will." +
          "<img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passages.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
          "<br/><br/>Using the dropdown list provided select a book from Scripture:" +
          "<img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passages-book.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
          "<br/><br/>Next select a chapter from the selected book:" +
          "<img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passages-chapter.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
          "<br/><br/>At this point you can press the <img src=\"/help-images/create-a-curated-song-flow-from-scripture/choose-song-book-not-logged-in-add-button.png\" style=\"width: 150px; height: auto;\"> button" +
          "<img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passages-book-chapter-selected.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
          "<br/><br/>Or if you wish to refine the Scripture search further you can also select a start and/or end verse within the selected book." +
          "<br/><br/>Having added your Scripture passage you will see it appear on the right hand side of the screen:" +
          "<img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passages-book-chapter-added.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
          "<br/><br/>Continue to add as many Scripture passages as you require and then press the Continue button at the bottom of the page."
    },
    {
      title: "Selected passages features",
      description: "There are several things you can do with a selected passage" +
          "<br/><br/><img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passaage-features.png\" style=\"width: 50%; height: auto; max-width: 100%;\">" +
          "<br/><br/>View the Scripture passage text by clicking <img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passaage-features-eye.png\" style=\"width: 40px; height: auto;\"> icon." +
          "<br/><br/><img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passaage-features-biblegateway.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
          "<br/><br/>Remove the Scripture passage from your list by clicking <img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passaage-features-trash.png\" style=\"width: 40px; height: auto;\"> icon."
    },//build-from-scripture-choose-passaage-songs
    {
      title: "Choose songs",
      description: "You are now presented with a list of all songs from the selected song book(s) for the Scripture passages selected." +
          "<br/><br/><img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passaage-songs.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
          "<br/><br/>Each song has a selector toggle:" +
          "<br/><br/><img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passaage-song.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
          "<br/><br/>Click the selector toggle to add the specific song to your curated song-flow:" +
          "<br/><br/><img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passaage-song-toggled.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
          "<br/><br/>When you have selected all the song you wish for your song-flow click the Curate Song-flow button at the bottom of the page."
    },
    {
      title: "What's next",
      description: "You now have the start of a curated song-flow:" +
          "<br/><br/><img src=\"/help-images/create-a-curated-song-flow-from-scripture/build-from-scripture-choose-passaage-curated-songs.png\" style=\"width: 100%; height: auto; max-width: 100%;\">" +
          "<br/></br><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/create-a-curated-song-flow-from-scripture'>Add another song based on a Scripture passage</a>" +
          "<br/></br><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/create-a-curated-song-flow-from-themes'>Add a song based on a Theme</a>" +
          "<br/></br><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/creating-your-first-curated-song-flow'>Add a song by using search</a>",
      image: "/help-images/well-done.png",
      enlargeable: false
    },
  ];


  render() {
    return (
      <>
        <SeoHelper
            uri="/help/create-a-curated-song-flow-from-scripture"
            title = "Create a curated song-flow from scripture | Help | The Worship Bible"
            description={"Learn how to create a curated song-flow from a scripture reference"}
        />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>help</span>
                      </h1>
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-primary rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-check-bold" />*/}
                          {/*</div>*/}
                          <Row className="mt-3">
                            <Col>
                              <div className="d-flex align-items-center mb-3">
                                <RiBookMarkedFill color="#5e72e4" size="24" className="mr-2"/>
                                <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">Create a curated song-flow from Scripture</h2>
                              </div>
                            </Col>
                            <Col md="3" xs="12">
                              <Button
                                  block
                                  type="submit"
                                  className="mb-2"
                                  color="white"
                                  href="/help"
                              >
                                <span className="btn-inner--text">Back to help</span>
                              </Button>
                            </Col>
                          </Row>
                          <p className="description mt-3">
                            <InstructionsWizard stepsData={this.stepsData} />
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default CreateACuratedSongFlowFromScriptureHelp;
